/*
 * @Author: zuoxuecheng
 * @Date: 2024-07-08 15:23:31
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import service from '../axios';

// 通过cn码添加打印机
export function addprinter(data) {
    return service({
        url: '/work/work/addprinter',
        method: 'post',
        data
    })
}

// 获取打印机列表
export function getPrinters(data) {
    return service({
        url: '/work/printer/getPrinters',
        method: 'get',
        params: data
    })
}

// 打印机详情
export function getInfo(data) {
    return service({
        url: '/v2/printer/info',
        method: 'get',
        params: data
    })
}

// 打印任务详情
export function getTaskInfo(data) {
    return service({
        url: '/v2/project/info',
        method: 'get',
        params: data
    })
}

// 打印机重命名
export function rename(data) {
    return service({
        url: '/work/printer/Info',
        method: 'post',
        data
    })
}


// 打印机重命名
export function unsetprinters(data) {
    return service({
        url: '/work/printer/unsetprinters',
        method: 'get',
        params:data
    })
}

export function getTcCosTempToken(data) {
    return service({
        url: '/user/cloud_storage/getTcCosTempToken',
        method: 'post',
        data
    })
}

export function getAwsToken (data) {
  return service({
    url: '/api/work/operation/sendOrder?checkSign=false',
    method: 'post',
    data
  })
}

export function postSendOrder(data) {
    return service({
        url: '/work/operation/sendOrder',
        method: 'post',
        data
    })
}

// 打印机功能
export function functions(data) {
    return service({
        url: '/v2/printer/functions',
        method: 'get',
        params: data
    })
}

export function getPrinterOptions(data) {
    return service({
        url: '/api/v2/device/getPrinterOptions',
        method: 'post',
        data
    })
}

export function updateVersion(data) {
    return service({
        url: '/work/printer/update_version',
        method: 'get',
        params: data
    })
}

export function updateBoxVersion(data) {
    return service({
        url: '/v2/printer/update_multi_color_box_version',
        method: 'post',
        data
    })
}

export function unsetprojects(data) {
    return service({
        url: '/work/project/unsetprojects',
        method: 'post',
        data
    })
}

export function getListSetting(data) {
    return service({
        url: '/v3/printer/getList',
        method: 'get',
        params: data
    })
}

//  获取打印信息
export function postProjectCommentInfo (data) {
  return service({
    url: '/v3/work/getProjectCommentInfo',
    method: 'post',
    data
  })
}

//  提交评分
export function postSumbitComment (data) {
  return service({
    url: '/v3/work/sumbitComment',
    method: 'post',
    data
  })
}

//  orca切片软件获取文件列表
export function postUserFiles (data) {
  return service({
    url: '/v3/index/userFiles',
    method: 'post',
    data
  })
}

//  获取用户已经使用的存储空间
export function postUserStore (data) {
  return service({
    url: '/work/index/getUserStore',
    method: 'post',
    data
  })
}

//  文件重命名
export function renameFile (data) {
  return service({
    url: '/work/index/renameFile',
    method: 'post',
    data
  })
}

//  获取文件下载链接
export function getDowdLoadUrl (data) {
  return service({
    url: '/work/index/getDowdLoadUrl',
    method: 'post',
    data
  })
}

//  获取文件下载链接
export function getDownloadUrls (data) {
  return service({
    url: '/work/index/getDownloadUrls',
    method: 'post',
    data
  })
}

//  用户删除已经上传文件
export function delFiles (data) {
  return service({
    url: '/work/index/delFiles',
    method: 'post',
    data
  })
}

// v2-用户文件上传前锁定存储空间-v2
export function lockStorageSpace (data) {
  return service({
    url: '/v2/cloud_storage/lockStorageSpace',
    method: 'post',
    data
  })
}

// v2-用户释放锁定的存储空间(文件上传成功且业务逻辑处理完成后或上传失败)
export function unlockStorageSpace (data) {
  return service({
    url: '/v2/cloud_storage/unlockStorageSpace',
    method: 'post',
    data
  })
}

// v2-用户上传模型、切片、压缩等格式文件
export function newUploadFile (data) {
  return service({
    url: '/v2/profile/newUploadFile',
    method: 'post',
    data
  })
}

//  获取打印机的云端、打印机本地、u盘文件以及打印中任务的多色和零件
export function getPrinterFileDetails (data) {
  return service({
    url: '/v3/printer/getPrinterFileDetails',
    method: 'post',
    data
  })
}